import type { Leena2Interval } from '@upright/common/model/output/scores/leena2-intervals';
import styled from 'styled-components';
import { formatLeena2Interval, formatLeena2Number, LEENA2_INTERVAL_TITLE, NumberFormatter } from './format';

/**
 * A muted, inline Leena-2 80% interval: "(2.1–8.0)" by default, or with a
 * `prefix` such as "80%: 2.1–8.0". Renders nothing without an interval, so a
 * caller can pass whatever it has and generative results stay unchanged.
 */
export function Leena2IntervalText(props: {
  interval: Leena2Interval | undefined;
  format?: NumberFormatter;
  /** Text before the bounds; omit for the parenthesised form. */
  prefix?: string;
  /** Appended after the upper bound, e.g. "%" or " ¢/$". */
  suffix?: string;
  className?: string;
}) {
  const { interval, format = formatLeena2Number, prefix, suffix = '' } = props;
  if (!interval) return null;
  const text = `${formatLeena2Interval(interval, format)}${suffix}`;
  return (
    <Muted className={props.className} title={LEENA2_INTERVAL_TITLE}>
      {prefix !== undefined ? `${prefix}${text}` : `(${text})`}
    </Muted>
  );
}

const Muted = styled.span`
  color: var(--color__gray-500);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;
